import type { UseQueryResult } from '@tanstack/react-query';
import type { ReactNode } from 'react';
import { ApiError } from '../api/client.js';
import { t } from '../i18n/uk.js';

interface Props<T> {
  query: Pick<UseQueryResult<T>, 'status' | 'data' | 'error' | 'refetch'>;
  children: (data: T) => ReactNode;
}

/** The one loading / error / data convention for every screen. */
export function QueryState<T>({ query, children }: Props<T>) {
  if (query.status === 'pending') {
    return (
      <p role="status" className="muted">
        {t.common.loading}
      </p>
    );
  }
  if (query.status === 'error') {
    const detail = query.error instanceof ApiError ? query.error.problem?.detail : undefined;
    return (
      <div role="alert" className="error">
        <p>{t.common.loadFailed}</p>
        {detail && <p className="muted">{detail}</p>}
        <button type="button" onClick={() => void query.refetch()}>
          {t.common.retry}
        </button>
      </div>
    );
  }
  return <>{children(query.data as T)}</>;
}
